import * as Sentry from "@sentry/react";
import { caseObject } from "@store/cases/casesSlice";
import { Condition, ConditionTypes } from "@types-runway/condition";
import { RunwayPrice } from "@types-runway/state";

import { condition, stripe } from "../../api";

const useFindConditions = () => {
  const findConditionByName = async (name: ConditionTypes): Promise<Condition> => {
    let conditions = caseObject.data.conditions;
    try {
      const { data } = await condition.conditionPost("/search", {
        metadata: {
          name,
        },
      });
      conditions = data;
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      return conditions[0];
    }
  };

  const findConditionsByPrices = async (pricesIds: string[]): Promise<RunwayPrice[]> => {
    let prices: RunwayPrice[] = [];
    try {
      const { data } = await stripe.stripePost("prices", {
        pricesIds,
      });
      prices = data;
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      return prices;
    }
  };

  return { findConditionByName, findConditionsByPrices };
};

export default useFindConditions;
